import React from "react";
import "./ThemeToggle.css";
import { useTheme } from "../context/ThemeContext";

const ThemeToggle: React.FC = () => {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <div className="theme-toggle-wrapper">
      <input
        type="checkbox"
        id="theme-toggle"
        className="theme-toggle-checkbox"
        checked={isDark}
        onChange={toggleTheme}
      />
      <label htmlFor="theme-toggle" className="theme-toggle-label">
        {/* Background Decorations */}
        <div className="bg-decorations">
          {/* Clouds */}
          <div className="bg-cloud bg-cloud-1"></div>
        </div>

        {/* Toggle Button */}
        <span className="theme-toggle-button">
          <div className="sun"></div>
          <div className="moon">
            <div className="crater crater-1"></div>
            <div className="crater crater-2"></div>
            <div className="crater crater-3"></div>
          </div>
        </span>
      </label>
    </div>
  );
};

export default ThemeToggle;
